import { RefinementList } from './refinement-list'
import { ColorRefinementList } from './color-refinement-list'
import { RangeInput } from './range-input'
import {
  RefinementOptions,
  RefinementFurnitureType,
  RefinementFlooringType,
  FurnitureFacetFiltersKey,
  FlooringFacetFiltersKey,
} from 'types'

export interface RefinementsPanelItemProps {
  type: (RefinementFurnitureType | FurnitureFacetFiltersKey) | (RefinementFlooringType | FlooringFacetFiltersKey)
}

export const RefinementsPanelItem = ({ type, ...props }: RefinementsPanelItemProps & RefinementOptions) => {
  switch (type) {
    case 'colors':
      return (
        <ColorRefinementList
          {...props}
          attribute={props.attribute as string}
          limit={props.limit as number}
          showMore={props.showMore as boolean}
          showMoreLimit={props.showMoreLimit as number}
        />
      )

    case 'price':
      return <RangeInput {...props} attribute={props.attribute as string} />

    default:
      return (
        <RefinementList
          {...props}
          attribute={props.attribute as string}
          limit={props.limit as number}
          showMore={props.showMore as boolean}
          showMoreLimit={props.showMoreLimit as number}
        />
      )
  }
}
